import { useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";

import { onboardingSteps } from "../configs/onboarding-steps";

export function OnboardingMobileNavigation() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [initialScroll, setInitialScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 150);
      if (!initialScroll && window.scrollY >= 150) {
        setInitialScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [initialScroll]);

  const currentStepIndex = onboardingSteps.findIndex(
    (step) => matchPath(step.slug, location.pathname) !== null,
  );

  const currentStep = onboardingSteps[currentStepIndex];

  if (!currentStep) return null;

  return (
    <>
      <div className="flex h-14 items-center justify-end px-4 py-3 lg:hidden">
        <p className="text-sm text-secondary">
          Step {currentStepIndex + 1} of {onboardingSteps.length}
        </p>
      </div>

      <div
        className={cn(
          "animate__animated animate__faster fixed top-0 flex h-14 w-full items-center justify-between bg-background px-4 py-2 shadow-md lg:hidden",
          scrolled ? "animate__slideInDown" : "animate__slideOutUp",
          !initialScroll && "hidden",
        )}
      >
        <div className="flex items-center gap-2">
          <div className="inline-flex items-center justify-center rounded-sm border border-border bg-background p-2 shadow-sm dark:text-white">
            <currentStep.icon className="h-4 w-4" aria-hidden="true" />
          </div>
          <p className="text-sm font-semibold text-foreground">
            {currentStep.title}
          </p>
        </div>
        <p className="text-sm text-secondary">
          Step {currentStepIndex + 1} of {onboardingSteps.length}
        </p>
      </div>
    </>
  );
}
